import * as React from "react"
import * as ReactDom from "react-dom"
import Allies from "../components/views/Allies";
import { requestPageData } from "../services/api";
import { checkLang, setCurrentPage } from "../services/general";

export const page = async () => {
	const alliesContainer = document.getElementById('allies')
	const ALLIESINFO = window.drupalSettings.react.node || await requestPageData({ content: "partner", nid: alliesContainer.dataset.nid, langcode: checkLang() })
	ReactDom.render(<Allies data={ALLIESINFO} />, alliesContainer)
	setCurrentPage('allies')
}